'use client';

import { useEffect, useState } from 'react';

/**
 * 'dark' | 'light' según la app: clase `.dark` o `data-theme` en <html>
 * (lo que ponen next-themes, el ThemeProvider de la librería o el SDK).
 * Sin ninguna de las dos marcas es 'light': el sistema operativo NO decide,
 * para no oscurecer el sidebar de una app que no tiene modo oscuro.
 */
export function readDocumentTheme() {
  if (typeof document === 'undefined') return 'light';
  const html = document.documentElement;
  if (html.classList.contains('dark')) return 'dark';
  return html.getAttribute('data-theme') === 'dark' ? 'dark' : 'light';
}

export function useDocumentTheme(enabled) {
  const [theme, setTheme] = useState(() => (enabled ? readDocumentTheme() : 'light'));

  useEffect(() => {
    if (!enabled || typeof MutationObserver === 'undefined') return undefined;
    setTheme(readDocumentTheme());
    const observer = new MutationObserver(() => setTheme(readDocumentTheme()));
    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['class', 'data-theme'],
    });
    return () => observer.disconnect();
  }, [enabled]);

  return theme;
}
